var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"channel-list"},_vm._l((_vm.channelList),function(channel,idx){return _c('img',{key:idx,staticClass:"channel-item",attrs:{"src":channel.qrCodeUrl}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }